export const inviteKeys = {
  all: ['invites'] as const,
  lists: () => [...inviteKeys.all, 'list'] as const,
  userInvitations: () => [...inviteKeys.lists(), 'user-invitations'] as const,
  userConnections: () => [...inviteKeys.lists(), 'user-connections'] as const,
  userPendingInvitations: () => [...inviteKeys.lists(), 'user-pending-invitations'] as const,
  details: () => [...inviteKeys.all, 'detail'] as const,
  detail: (inviteCode: string) => [...inviteKeys.details(), inviteCode] as const,
};
